import { generatePath } from 'react-router-dom'
import { routeConfig } from 'src/routes/config.js'

/**
 * Builds a lookup table of cross MFE links based on predefined supported names and
 * their respective routes from the routing configuration.
 *
 * @returns {object} Object structure containing cross MFE links categorized by the MFE key.
 */
const buildCrossMfeLinks = () => {
    return routeConfig.reduce((links, route) => {
        if (route.crossMfeKey) {
            links[route.crossMfeKey] = route.path
        }
        return links
    }, {})
}

/**
 * Lookup table of cross MFE links.
 */
export const CROSS_MFE_LINKS = buildCrossMfeLinks()

/**
 * Generates a URL path for a given MFE link and parameters.
 *
 * @param {object} link The link object containing the path template.
 * @param {object} [params={}] Optional parameters to populate the path template.
 * @param {object} [queryParams={}] Optional query parameters.
 * @returns {string} The generated path with parameters inserted.
 */
export const createMfeLink = (link, params = {}, queryParams = {}) => {
    const basePath = generatePath(link, params)
    const query = new URLSearchParams(queryParams)
    const queryString = query.toString()

    return queryString ? `${basePath}?${queryString}` : basePath
}
